var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1150,
    height: 363,
    viewBox: "0 0 1150 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M474.258 154.859C531.333 183.041 661.009 162.818 698.635 153.001C744.211 141.109 834.501 52.4988 930.001 41.9991C1071.83 26.4054 1165.29 184.308 1135.33 272.324C1100.98 373.259 925.163 322.032 900.576 320.984C883.829 320.27 754.208 287.75 729.385 279.944C709.964 273.835 587.094 248.96 551.019 247.422C501.323 245.304 375.255 276.792 336.663 296.951C298.072 317.111 124.753 338.277 63.5703 298.292C2.38707 258.306 -13.8099 146.519 34.4903 70.7056C82.7904 -5.10755 235.735 36.7589 259.072 51.7237C285.088 68.4068 402.915 119.631 474.258 154.859Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectbg);
export default __webpack_public_path__ + "static/media/connectbg.ae6c8a25585f60ce6ce74666be93c6c0.svg";
export { ForwardRef as ReactComponent };